import { createHooks } from '@wordpress/hooks';

/**
 * Initializes a hooks system to extend the functionality of the WPGraphQL IDE through
 * external scripts and internal plugin hooks.
 */
const hooks = createHooks();

export default hooks;
